import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { identity } from 'rambdax';
import NumberFormatInput from './NumberFormatInput';

export default function ControlledNumberInput({
  control,
  error,
  id,
  label,
  name,
  parse = identity,
  prefix = '',
  rules = {},
  size = 'small',
  thousandSeparator = false,
  ...props
}) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => {
        return (
          <NumberFormatInput
            allowNegative={false}
            className="flex-1"
            id={`${id}-controlled-input`}
            isNumericString
            label={label}
            onChange={({ target: { value: inputValue } }) =>
              onChange(parse(inputValue))
            }
            prefix={prefix}
            size={size}
            thousandSeparator={thousandSeparator}
            value={value}
            variant="outlined"
            {...{
              ...props,
              error: !!error,
            }}
          />
        );
      }}
    />
  );
}

ControlledNumberInput.propTypes = {
  control: PropTypes.object.isRequired,
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  parse: PropTypes.func,
  prefix: PropTypes.string,
  size: PropTypes.string,
  thousandSeparator: PropTypes.bool,
};
